import React, { Component } from "react";
import "./CarView.css";

import store from "../../store";
import { Route, Link, BrowserRouter as Router } from "react-router-dom";

import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import CarViewDetail from "../CarViewDetail/CarViewDetail";

import CarViewCircles from "../CarViewCircles/CarViewCircles";

import CarViewTextDetail from "../CarViewTextDetail/CarViewTextDetail";

import { createMuiTheme } from "@material-ui/core/styles";
import green from "@material-ui/core/colors/green";
import CarGallery from "../CarGallery/CarGallery";
import { isMobile } from "react-device-detect";

const ColorButton = withStyles(theme => ({
  root: {
    fontFamily: "Arial",
    fontWeight: "bold",
    borderColor: green[500],
    backgroundColor: green[500],
    color: theme.palette.getContrastText(green[50]),
    color: green[50],
    borderRadius: 20,
    "&:hover": {
      backgroundColor: green[100],
      color: theme.palette.getContrastText(green[500]),
      color: green[700]
    }
  }
}))(Button);

const imgStyle = {
  width: "50%",
  height: "50%",
  display: "block",
  marginLeft: "auto",
  marginRight: "auto"
};

class CarView extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}

  useStyles = () =>
    makeStyles(theme => ({
      button: {
        margin: theme.spacing(1),
        primary: green
      },
      input: {
        display: "none"
      }
    }));

  startHandler = () => {
    this.props.history.replace("/game");
  };

  leaderboardHandler = () => {
    this.props.history.replace("/leaderboard");
  };

  render() {
    const classes = this.useStyles();

    return (
      <div>
        <Header />
        <CarViewDetail
          image="img/cars/corolla-gray-big.png"
          modelName={"COROLLA"}
          version={"1.8 Se-g Cvt"}
          price={"$1.200.577"}
          version={"XLS"}
          motor={"Motor 1.5"}
          tipo={"HATCHBACK"}
          color={"Blanco"}
          year={"2019"}
          gear={"MANUAL"}
          titulo1={"Diseño Exterior"}
          texto1={
            "Diseño superior, con líneas que destacan un vehículo imponente."
          }
          titulo2={"Seguridad"}
          texto2={"Equipamiento de seguridadsin precedentes en toda la gama."}
          titulo3={"Confort"}
          texto3={"Placer de manejo inigualable."}
        />
        {isMobile ? null : (
          <CarViewCircles
            version={"XLS"}
            motor={"Motor 1.5"}
            tipo={"HATCHBACK"}
            color={"Blanco"}
            year={"2019"}
            gear={"MANUAL"}
          />
        )}
        {isMobile ? null : (
          <CarViewTextDetail
            titulo1={"Diseño Exterior"}
            texto1={
              "Diseño superior, con líneas que destacan un vehículo imponente."
            }
            titulo2={"Seguridad"}
            texto2={"Equipamiento de seguridadsin precedentes en toda la gama."}
            titulo3={"Confort"}
            texto3={"Placer de manejo inigualable."}
          />
        )}
        {isMobile ? null : <CarGallery className="CarGallery" />}
        {isMobile ? null : <Footer />}
      </div>
    );
  }
}

export default CarView;
